var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagetypeActiveHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Image_type_Active_-_Hover_",
    "data-name": "Image type | Active - Hover ",
    d: "M9.545,5A4.55,4.55,0,0,0,5,9.545v8.6l4.148-4.013a2.369,2.369,0,0,1,3.216,0l3.15,3.048,1.27-1.23a2.3,2.3,0,0,1,1.6-.65h0A2.3,2.3,0,0,1,20,15.954l4.983,4.82c.008-.106.017-.212.017-.32V9.545A4.55,4.55,0,0,0,20.455,5Zm9.091,4.848a1.515,1.515,0,1,1-1.515,1.515A1.515,1.515,0,0,1,18.636,9.848Zm-7.881,5.459a.5.5,0,0,0-.344.134l-5.4,5.225a4.55,4.55,0,0,0,2.784,3.982l6.411-6.2L11.1,15.442A.5.5,0,0,0,10.755,15.308Zm7.637,1.813a.491.491,0,0,0-.343.138l-8,7.74H20.455a4.544,4.544,0,0,0,3.931-2.274l-5.65-5.466A.49.49,0,0,0,18.393,17.121Z",
    transform: "translate(-5 -5)",
    fill: "#0f7bff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagetypeActiveHover);
export default __webpack_public_path__ + "static/media/Image type  Active - Hover.bedbd6aa.svg";
export { ForwardRef as ReactComponent };